import { Button, TButtonType } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import useStores from '../stores/UseStores';

export interface LoginButtonProps {
  isLoading: boolean;
  disabled?: boolean;
  type?: TButtonType;
  text?: string;
  onClick?: () => void;
}

const LoginButton = (props: LoginButtonProps): JSX.Element => {
  const { isLoading, disabled, type, text, onClick } = props;
  const {
    translateStore: { translate }
  } = useStores();

  return (
    <Button
      text={text || translate('button.login')}
      iconRight="#arrow-right"
      block={true}
      isLoading={isLoading}
      disabled={disabled}
      type={type}
      attributes={{ type: 'submit' }}
      onClick={() => onClick && onClick()}
    />
  );
};

export default observer(LoginButton);
